import {
  AspectRatio,
  Box,
  Flex,
  FlexProps,
  Image,
  Stack,
  Text,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react";
import React from "react";

type TextBannerProps = FlexProps;

export const TextBanner: React.FC<TextBannerProps> = ({
  children,
  ...rest
}) => {
  return (
    <Flex
      backgroundColor={"#ffd1d2"}
      p={4}
      borderRadius={6}
      mb={12}
      flexDirection={"column"}
      {...rest}
    >
      {children}
    </Flex>
  );
};
